

/*
vim: fileformat=unix syntax=JavaScript tabstop=4 shiftwidth=4 expandtab fileencoding=utf8
*/
/* jslint browser: true */

import * as _matrix from 'transformation-matrix';

const POINT_IN_MILLIS = 72.0 / 25.4;
const MILLIS_IN_POINTS = 25.4 / 72.0;
const pointsToMillisMatrix = _matrix.scale(MILLIS_IN_POINTS, MILLIS_IN_POINTS);
const millisToPointsMatrix = _matrix.scale(POINT_IN_MILLIS, POINT_IN_MILLIS);
function toFloat(n) {
    return (typeof (n) === 'number') ? n : parseFloat(n);
}

export class PdfLocation {
    constructor({
        x, y, w, h, pointsToScrenRatio,
    }) {
        this.x = toFloat(x || 0);
        this.y = toFloat(y || 0);
        this.w = toFloat(w || 0);
        this.h = toFloat(h || 0);
        this.pointsToScrenRatio = pointsToScrenRatio ? toFloat(pointsToScrenRatio) : null;
    }
    transform(matrix) {
        const [{ x: x1, y: y1 }, { x: x2, y: y2 }] = _matrix.applyToPoints(matrix, [this, { x: this.x1, y: this.y1 }]);
        //normalize
        this.x = Math.min(x1, x2);
        this.y = Math.min(y1, y2);
        this.w = Math.max(x1, x2) - this.x;
        this.h = Math.max(y1, y2) - this.y;
        return this;
    }
    get x1() { return this.x + this.w; }
    get y1() { return this.y + this.h; }

    get x_r() { return Math.round(this.x); }
    get y_r() { return Math.round(this.y); }
    get w_r() { return Math.round(this.w); }
    get h_r() { return Math.round(this.h); }
}

export class PdfLocationPoints extends PdfLocation {
    toPoints() {
        return this;
    }
    toMillis() {
        return new PdfLocationMillis(this).transform(pointsToMillisMatrix);
    }
    toPixels({ pointsToScrenRatio, millisToScrenRatio } = {}) {
        if(!pointsToScrenRatio && !millisToScrenRatio) {
            if(!this.pointsToScrenRatio)
                throw new Error('Unknown ratio');
            pointsToScrenRatio = this.pointsToScrenRatio;
        }
        pointsToScrenRatio = pointsToScrenRatio || (millisToScrenRatio * POINT_IN_MILLIS);
        return new PdfLocationScreenPixels(Object.assign({}, this, { pointsToScrenRatio }))
            .transform(_matrix.scale(1 / pointsToScrenRatio));
    }
}

export class PdfLocationMillis extends PdfLocation {
    toPoints() {
        return new PdfLocationPoints(this).transform(millisToPointsMatrix);
    }
    toMillis() {
        return this;
    }
    toPixels({ pointsToScrenRatio, millisToScrenRatio } = {}) {
        if(!pointsToScrenRatio && !millisToScrenRatio) {
            if(!this.pointsToScrenRatio)
                throw new Error('Unknown ratio');
            pointsToScrenRatio = this.pointsToScrenRatio;
        }
        millisToScrenRatio = millisToScrenRatio || (pointsToScrenRatio * MILLIS_IN_POINTS);
        pointsToScrenRatio = pointsToScrenRatio || (millisToScrenRatio * POINT_IN_MILLIS);
        return new PdfLocationScreenPixels(Object.assign({}, this, { pointsToScrenRatio }))
            .transform(_matrix.scale(1 / millisToScrenRatio));
    }
}

export class PdfLocationScreenPixels extends PdfLocation {
    toPoints() {
        return new PdfLocationPoints(this).transform(_matrix.scale(this.pointsToScrenRatio));
    }
    toMillis() {
        return new PdfLocationMillis(this).transform(_matrix.scale(this.pointsToScrenRatio * MILLIS_IN_POINTS));
    }
    toPixels({ pointsToScrenRatio, millisToScrenRatio } = {}) {
        if(!pointsToScrenRatio && !millisToScrenRatio) {
            if(!this.pointsToScrenRatio)
                throw new Error('Unknown ratio');
            pointsToScrenRatio = this.pointsToScrenRatio;
        }
        pointsToScrenRatio = pointsToScrenRatio || (millisToScrenRatio * POINT_IN_MILLIS);
        if(pointsToScrenRatio === this.pointsToScrenRatio)
            return this;
        return new PdfLocationScreenPixels(Object.assign({}, this, { pointsToScrenRatio }))
            .transform(_matrix.scale(pointsToScrenRatio / this.pointsToScrenRatio));
    }
}
